import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Room } from "../types/RoomsTypes";

interface RoomsState {
  rooms: Room[];
  loading: boolean;
  error: string | null;
  selectedRoom: Room | null;
}

const initialState: RoomsState = {
  rooms: [],
  loading: false,
  error: null,
  selectedRoom: null,
};

const roomsSlice = createSlice({
  name: "rooms",
  initialState,
  reducers: {
    setRooms: (state, action: PayloadAction<Room[]>) => {
      state.rooms = action.payload;
      state.loading = false;
      state.error = null;
    },
    setSelectedRoom: (state, action: PayloadAction<Room | null>) => {
      state.selectedRoom = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },
    getRoom: (state, action: PayloadAction<number | string>) => {
      const room = state.rooms.find(
        (roomItem) => roomItem.id_room === action.payload,
      );
      state.selectedRoom = room || null;
    },
    clearRooms: (state) => {
      state.rooms = [];
      state.selectedRoom = null;
      state.error = null;
      state.loading = false;
    },
  },
});

export const {
  setRooms,
  setSelectedRoom,
  setLoading,
  setError,
  clearRooms,
  getRoom,
} = roomsSlice.actions;

export default roomsSlice.reducer;
